import { wrap } from "./root-providers";

export const wrapRootElement = wrap;
